<template>
  <div class="attendance-repair-application-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">申请人：</span>
        </div>
        <el-select v-model="formData.personCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item.personCode"
                     :label="item.personName" :value="item.personCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">补卡时间：</span>
        </div>
        <el-date-picker v-model="formData.repairCardTime" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" size="small" style="width: 280px" placeholder="补卡时间"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">补卡类型：</span>
        </div>
        <el-checkbox v-model="checkInState">上班补卡</el-checkbox>
        <el-checkbox v-model="checkOutState">下班补卡</el-checkbox>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">补卡原因：</span>
        </div>
        <el-input v-model="formData.reason" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm value="保存" @confirm="confirm('1')" />
        <button-cancel value="保存并提交审批" @cancel="confirm('2')" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import {bus} from '../../../utils/bus'
import {api} from '../../api/AttendancePoint'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'attendance-overtime-application-add',
  data () {
    return {
      breadcrumb: [{
        value: '智慧考勤',
        name: 'attendance-department-manage'
      }, {
        value: '补卡申请'
      }],
      mainTitle: '添加补卡申请',
      subheading: '',

      responsiblePersonList: [],
      overtimeRuleList: [],
      checkInState: false,
      checkOutState: false,
      formData: {
        personCode: '',
        personName: '',
        repairCardTime: '',
        reason: '',
        checkIn: '',
        checkOut: ''
      },
    }
  },
  created () {
    this.remoteMethod()
    this.getAttendanceOvertimeList()
  },
  methods: {
    remoteMethod (query) {
      this.getPersonList(query)
    },

    // 获取人员列表
    getPersonList (searchKey) {
      this.$axios.post(api.getAttendanceGroupUserList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let list = res.data.data
          this.responsiblePersonList = list
        })
        .catch(errorHandler('获取人员列表失败'))
    },

    getAttendanceOvertimeList () {
      this.$axios.post(api.getAttendanceOvertimeList, {})
        .then(res => {
          let list = res.data.data
          this.overtimeRuleList = list
        })
        .catch(errorHandler('获取加班规则失败'))
    },

    toManagementPage () {
      this.$router.push({
        name: 'attendance-repair-application-manage'
      })
    },

    // 添加
    confirm (type) {
      if (!this.formData.personCode) {
        nError('请选择申请人')
        return false
      }
      if (!this.formData.repairCardTime) {
        nError('请选择补卡时间')
        return false
      }
      if (!this.formData.reason) {
        nError('请输入补卡原因')
        return false
      }
      if (!this.checkInState && !this.checkOutState) {
        nError('请选择补卡类型')
        return false
      }
      this.formData.checkIn = this.checkInState ? '1' : '0'
      this.formData.checkOut = this.checkOutState ? '1' : '0'
      this.responsiblePersonList.map(v => {
        if (v.personCode === this.formData.personCode) {
          this.formData.personName = v.personName
        }
      })
      this.$axios.post(api.addRepairCard, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            let code = res.data.data
            nSuccess('保存成功')
            if (type === '1') {
              this.toManagementPage()
            } else if (type === '2') {
              this.submitRepairCard(code)
            }
          }
        })
        .catch(errorHandler('保存失败'))
    },

    submitRepairCard (code) {
      this.$axios.post(api.submitRepairCard, {
        eventCode: code,
        sponsorAccountCode: bus.global.accountCode,
        sponsorAccountName: bus.global.accountName,
        digest: ''
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('操作成功')
            this.toManagementPage()
          }
        })
        .catch(errorHandler('操作失败'))
    },

    cancel () {
      this.toManagementPage()
    }
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line>div {
  margin-right: 20px;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 600px;
  padding: 0 110px 0 110px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #D7D7D7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: .7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
.attendance-repair-application-add {
  .el-checkbox__label {
    width: auto!important;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceRepairApplication/AttendanceRepairApplicationAdd.vue